module.exports = __webpack_public_path__ + "img/noImg.12b2f04a.png";